import { translations } from "@/constants/translations";
import type { LanguageType } from "@/store/types/language";
import { telemetry } from "@/telemetry";

let termsTimer: (() => number) | undefined;

export const startRegistrationTimer = () => {
  termsTimer = telemetry.startTimer();
};

export const getSecondsSinceTermsViewed = () =>
  termsTimer && Math.round(termsTimer() / 1000);

export const getOrgTypes = (activeLanguage: LanguageType) => {
  const language = translations.pages["account-registration"][activeLanguage];

  return [
    {
      label: language.corporation,
      value: "Corporation",
    },
    {
      label: language.partnership,
      value: "Partnership",
    },
    {
      label: language.government_provincial,
      value: "Government Federal",
    },
    {
      label: language.government_territory,
      value: "Government Territory",
    },
    {
      label: language.municipality,
      value: "Municipality",
    },
  ];
};

export const getBusinessTypes = (activeLanguage: LanguageType) => {
  const language = translations.pages["account-registration"][activeLanguage];

  return [
    {
      label: language.first_responder,
      value: "First responder",
    },
    {
      label: language.physician,
      value: "Physician",
    },
    {
      label: language.wholesaler,
      value: "Wholesaler",
    },
    {
      label: language.hospital,
      value: "Hospital",
    },
    {
      label: language.rehabilitation_organization,
      value: "Rehabilitation organization",
    },
    {
      label: language.pharmacy,
      value: "Pharmacy",
    },
    {
      label: language.specialty_distributor,
      value: "Specialty Distributor",
    },
    {
      label: language.government_agency,
      value: "Government agency",
    },
    {
      label: language.trust_estate,
      value: "Trust",
    },
    {
      label: language.foundation,
      value: "Foundation",
    },
    {
      label: language.university,
      value: "University",
    },
    {
      label: language.harm_organization,
      value: "Harm organization",
    },
    {
      label: language.school,
      value: "School",
    },
    {
      label: language.other,
      value: "Other",
    },
  ];
};
